import React from 'react';
import { FormSection } from '../../../libs/reduxForm';
import TextField from './TextField';

var LegalRepresentativeFieldGroup = function LegalRepresentativeFieldGroup(_ref) {
  var name = _ref.name;
  return React.createElement(FormSection, {
    name: name
  }, React.createElement(TextField, {
    label: 'First Name',
    name: 'first_name',
    placeholder: 'Enter First Name'
  }), React.createElement(TextField, {
    label: 'Last Name',
    name: 'last_name_1',
    placeholder: 'Enter Last Name'
  }), React.createElement(TextField, {
    label: 'Job Title',
    name: 'position',
    placeholder: 'Enter Job Title'
  }), React.createElement(TextField, {
    label: 'E-mail',
    name: 'email',
    placeholder: 'Enter E-mail'
  }));
};

export default LegalRepresentativeFieldGroup;